import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { BootScene } from "../BootScene";
import { Background } from "../../Background";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;
    
    constructor() {

        super("SplashScene");
        
        SplashScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        const bck = this.add.graphics();
        bck.fillStyle(0xffffff);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        const background = new Background(this);
        this.add.existing(background);

        const logo = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * 1 / 4, "texture_atlas_1", "logo");
        logo.scaleY = GameVars.scaleY;

        const playButton = new Button(this, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 + 80, "texture_atlas_1", "btn_play_splash", "btn_play_splash_hover");
        playButton.scaleY = GameVars.scaleY;
        playButton.onUp(this.onClickPlay, this);
        playButton.alpha = 0;
        this.add.existing(playButton);

        this.tweens.add({
            targets: playButton,
            alpha: 1,
            y: GameConstants.GAME_HEIGHT / 2 + 50,
            ease: Phaser.Math.Easing.Cubic.Out,
            delay: 850,
            duration: 400
        });

        this.tweens.add({
            targets: playButton,
            scaleX: 1.05,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 300,
            yoyo: true,
            repeat: -1
        });

        this.tweens.add({
            targets: playButton,
            scaleY: 1.05 * GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.InOut,
            delay: 250,
            duration: 300,
            yoyo: true,
            repeat: -1
        });

        let bottomLogo = this.add.image(GameConstants.GAME_WIDTH / 2 + 105, GameConstants.GAME_HEIGHT - 5, "texture_atlas_1", "logo_splashart");
        bottomLogo.scaleY = GameVars.scaleY;
        bottomLogo.setOrigin(.5, 1);

        bottomLogo = this.add.image(GameConstants.GAME_WIDTH / 2 - 245, GameConstants.GAME_HEIGHT - 5 - 130 * GameVars.scaleY, "texture_atlas_1", "logo_splashart");
        bottomLogo.scaleY = GameVars.scaleY;
        bottomLogo.setOrigin(.5, 1);
    }

    public onClickPlay(): void {

        if (!this.sys.game.device.os.desktop) {
            if (!this.game.scale.isFullscreen) {
                this.game.scale.startFullscreen();
                BootScene.onOrientationChange();
            }
        }

        this.cameras.main.fadeOut(300, 255, 255, 255);

        this.cameras.main.once("camerafadeoutcomplete", function (): void {
            GameManager.enterDifficultySelectionScene();
        });
    }
}
